import { useSelector } from "react-redux"

import { avatars } from "src/assets/images"
import { selectMyAvatar } from "src/store/economy"
import { DEFAULT_AVATAR } from "src/utils/cosmetics"

/* The signed-in player's own picture (owner, 2026-10-08), as the wallet last answered it. Before
   the wallet arrives it is the first free face, which is a picture of somebody rather than a
   blank square in the header. */
const MyAvatar = ({ className, alt = "" }) => {
  const worn = useSelector(selectMyAvatar)
  return <img src={avatars[worn] || avatars[DEFAULT_AVATAR]} alt={alt} className={className} />
}

export default MyAvatar
